import React from 'react';
import ReactDOM from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import App from './App';
import store from './app/store';
import i18n from './i18n';

const root = ReactDOM.createRoot(
  document.getElementById('react-root') as HTMLElement
);

root.render(
    <Provider store={store}>
      <I18nextProvider i18n={i18n}>
        <App />
      </I18nextProvider>
    </Provider>
);
